import ReportTemplate from "./report-template";

window.SchemaValidators = {
    ReportTemplate
}